
import EventCard from "../components/EventCard/EventCard"
import { useEffect, useState } from "react";

const EventContainer = ({}) => {

    const [events, setEvents] = useState([]);
  
    useEffect(() => {
      fetch("/templates/customWeb2/ModulesReact/buildInformationModule/data/events.json")
        .then((res) => res.json())
        .then((data) => setEvents(data))
        .catch((err) => console.error("Error cargando events.json:", err));
    }, []);

  return (
    <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)", // 3 columnas iguales
        gap: "20px", // espacio entre cartas
        width: "100%"}}>
        {events.map((event) =>(
            <EventCard
                key={event.name}
                imgSrc={event.img}
                spanTag="Evento"
                name={event.name}
                mapRespawn={event.map}
                reward={event.reward}
                coordStart = {event.coordinates}
                description= {event.description}
                color="rgba(16, 92, 60, 1)"
            />
        ))
        }
    </div>
  )

}

export default EventContainer